import { DashboardList } from "Components/DashboardList";

const DashboardPage = () => <DashboardList />;

export default DashboardPage;
